import { render, staticRenderFns } from "./RequestCash.vue?vue&type=template&id=12dd6bbe"
import script from "./RequestCash.vue?vue&type=script&lang=js"
export * from "./RequestCash.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports